import { render, staticRenderFns } from "./ImageLegend.vue?vue&type=template&id=79120cf8&name=image-legend&"
import script from "./ImageLegend.vue?vue&type=script&lang=js&"
export * from "./ImageLegend.vue?vue&type=script&lang=js&"
import style0 from "./ImageLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports